import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

type Props = {
  onClick: () => void;
};

const ResetFiltersButton: React.FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.button} onClick={onClick}>
      <i className="ico ico-retry" />
      <p>{t("Reset Filters")}</p>
    </div>
  );
};

export default ResetFiltersButton;
